<script lang="ts">
import { sendMessage } from "@microsoft/signalr/dist/esm/Utils";
import { navigate } from '../../app.logic';

  import { createEventDispatcher, onMount } from "svelte";
  import type { IActivityDTO } from "../../services/DTO";
  import { formatTimestampHuman } from "../../utils/date-utils";
import Button from "../Button.svelte";
  import Textarea from "../Form/Fields/Textarea.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";
import PortalUserDropdown from "./PortalUserDropdown.svelte";

  export let activities: IActivityDTO[] = [];
  export let entityId: number = 0;
  export let entityType: string = null;
  export let disabled: boolean = false;
  
  let commentOid = 0;
  let commentText = "";
  let assigneduser = null;
  let activitydto = null;

  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

  function onQuickEdit(activity: IActivityDTO) {
    activitydto = activity;
    commentOid = activity.oid;
    commentText = activity.activity.subject;
    assigneduser = activity.activity.assignedTo;
  }

  function onEdit(activity: IActivityDTO) {   
    dispatch("edit", { activity: activity }); 
    //navigate(`/task/${activity.oid}/${activity.entityType}`);
  }

  function onSave() {
    if (activitydto == null)
      activitydto = {
        oid: commentOid,
        entityId: entityId,
        entityType: entityType,
        activity: {
          subject: commentText,
          commentText: '',
          assignedTo: assigneduser
        },
      } as IActivityDTO;
    else
    {
      activitydto.activity.subject = commentText;
      activitydto.activity.assignedTo = assigneduser;
    } 

    dispatch("save", activitydto);
    commentOid = 0;
    commentText = "";
  }

  function onMarkComplete(comment: IActivityDTO) {     
    dispatch("complete", comment);
  }

  onMount(() => onLoad());
</script>

<div class="box">
  <h1 class="subtitle">Task <Button klass="is-small" on:click={onSave} {disabled} >Salva</Button></h1> 
  <FormField>
    <Textarea
      placeholder="Aggiungi task/promemoria rapido"
      required={false}
      {disabled}
      rows={2}
      maxlength={499}
      multiline={false}
      bind:value={commentText}
    />    
  </FormField>
  <FormField>
    <PortalUserDropdown
      name="Assegna a"
      placeholder="Assegna a"
      required={false}
      {disabled}  
      small={true}
      bind:value={assigneduser}
    />    
  </FormField>

  {#each activities as activity}
    <hr class="comment-separator" />
    <div class="comment-info">
      <span>
        <Icon
          name="edit"
          customRealIconStyle="font-size:18px;width:18px;"
          on:click={(_) => onQuickEdit(activity)}
        />
        <!--
        <Icon
          name="search"
          customRealIconStyle="font-size:18px;width:18px;"
          on:click={(_) => onEdit(activity)}
        />-->
        <Icon
          name="check"          
          customRealIconStyle="font-size:18px;width:18px;"
          on:click={(_) => onMarkComplete(activity)}
        />
      </span>
      <span class="comment-info-text">
        {#if activity.state != "" && activity.state != null}
          <span class="tag is-info">{activity.state}</span>
        {/if}    
      </span>
    </div>
    <div class="content">
      <!--
      {@html comment.commentText.replace(/\n/g, '<br>')}
      -->
      {activity.activity.subject}
    </div>
    <div class="comment-info" style="top:-1.2em;">
      <div class="comment-info-text">
          Creato: {formatTimestampHuman(activity.activity.createdOn)}
      </div>
      {#if activity.assignedUser != "" && activity.assignedUser != null}
      <div class="comment-info-text">
          Assegnato a: {activity.assignedUser}               
      </div>
      {/if}      
    </div> 
   
  {/each}
</div>

<style>
  .comment-separator {
    margin: 4px 0;
  }
  .comment-info {
    position: relative;
    line-height: 1em;
  }
  .comment-info-text {
    color: #999;
    font-size: x-small;
    display: inline-block;
    position: relative;
    top: 0px;
    margin-left: 2px;
  }
</style>
